export default "__VITE_ASSET__BneRLX2G__"